module.exports = __webpack_public_path__ + "img/basketball-hoop.696ee43b.svg";